import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogClose
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: "app-clear-device-list-dialog",
  templateUrl: "./clear-device-list-dialog.component.html",
  styleUrls: ["./clear-device-list-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatButton,
    MatDialogClose,
    MatIcon
  ]
})
export class ClearDeviceListDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ClearDeviceListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { isFlashing: boolean }
  ) {}
}
